import { PurchaseRequestAttachment } from './purchase-request-attachment';

export enum AttachmentOriginType {
  REQUESTER = 'REQUESTER',
  SUPPLIER = 'SUPPLIER'
}

export interface PurchaseRequestAttachmentGroup {
  name: string;
  avatar?: string;
  type: AttachmentOriginType;
  attachments: PurchaseRequestAttachment[];
}
